import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { TrainerProvider } from "./context/TrainerContext";
import { OwnerProvider } from "./context/OwnerContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import ErrorBoundary from "./components/commons/ErrorBoundary";
import SubscriptionModal from "./components/subscription/SubscriptionModal";
import LandingPage from "./components/auth/LandingPage";
import RegisterTrainer from "./components/auth/RegisterTrainer";
import RegisterSchool from "./components/auth/RegisterSchool";
import AddOpeningHours from "./components/auth/AddOpeningHours";
import RegisterOwner from "./components/auth/RegisterOwner";
import ConfirmTrainerRegistration from "./components/auth/ConfirmTrainerRegistration";
import RegisterTrainerSuccess from "./components/auth/RegisterTrainerSuccess";
import PrivateRoute from "./components/PrivateRoute";
import TrainerDashboard from "./components/trainer/TrainerDashboard";
import Podopieczni from "./components/trainer/Podopieczni";
import DogDetails from "./components/trainer/DogDetails";
import SurveyDetails from "./components/trainer/SurveyDetails";
import CreateSurvey from "./components/trainer/CreateSurvey";
import Calendar from "./components/trainer/calendar/Calendar";
import OwnersList from "./components/trainer/OwnersList";
import OwnerDetails from "./components/trainer/OwnerDetails";
import OwnerMyDog from "./components/owner/OwnerMyDog";
import OwnerDashboard from "./components/owner/OwnerDashboard";
import RegisterInvitedTrainer from "./components/auth/RegisterInvitedTrainer";
import OwnerCalendar from "./components/owner/school/OwnerCalendar";
import OwnerAccount from "./components/owner/OwnerAccount";
import TrainerAccount from "./components/trainer/TrainerAccount";
import TrainerWorkingHoursContent from "./components/trainer/TrainerWorkingHoursContent";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import Exercises from "./components/trainer/Exercises";
import SchoolDetails from "./components/trainer/SchoolDetails";
import OwnerTrainings from "./components/owner/OwnerTrainings";
import TrainerGroups from "./components/trainer/TrainerGroups";
import TrainerGroupDetails from "./components/trainer/TrainerGroupDetails";
import SurveyList from "./components/trainer/SurveyList";
import TrainerReportsManagement from "./components/trainer/TrainerReportsManagement";
import SubscriptionPlans from "./components/subscription/SubscriptionPlans";
import SubscriptionCancel from "./components/subscription/SubscriptionCancel";
import SubscriptionSuccess from "./components/subscription/SubscriptionSuccess";
import TrainerTrainings from "./components/trainer/TrainerTrainings";
import './App.css'
import { ToastProvider } from "./components/commons/toast/ToastContext";
import ToastContainer from "./components/commons/toast/ToastContainer";
import GracePeriodWarning from "./components/subscription/GracePeriodWarning";

const App = () => {
    return (
        <ErrorBoundary>
            <ToastProvider>
                <Router>
                    <SubscriptionProvider>
                        <ErrorBoundary>
                            <GracePeriodWarning />

                            <div className="app-container">
                                <Routes>
                                    <Route path="/" element={<LandingPage />} />
                                    <Route path="/register-trainer" element={<RegisterTrainer />} />
                                    <Route path="/register-school" element={<RegisterSchool />} />
                                    <Route path="/add-opening-hours" element={<AddOpeningHours />} />
                                    <Route path="/register-owner" element={<RegisterOwner />} />
                                    <Route path="/register-invited-trainer" element={<RegisterInvitedTrainer />} />
                                    <Route path="/confirm-trainer/:trainerId" element={<ConfirmTrainerRegistration />} />
                                    <Route path="/registration-success" element={<RegisterTrainerSuccess />} />
                                    <Route path="/forgot-password" element={<ForgotPassword />} />
                                    <Route path="/reset-password" element={<ResetPassword />} />

                                    <Route path="/subscription/plans" element={<SubscriptionPlans />} />
                                    <Route path="/subscription/success" element={<SubscriptionSuccess />} />
                                    <Route path="/subscription/cancel" element={<SubscriptionCancel />} />

                                    <Route path="/dashboard" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <TrainerDashboard />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/podopieczni" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <Podopieczni />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/dog/details/:dogId" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <DogDetails />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/survey/school/:schoolId/all" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <SurveyList />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/survey/create/:schoolId" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <CreateSurvey />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/survey/:surveyId/details" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <SurveyDetails />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/calendar" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <Calendar />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/school/details" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <SchoolDetails />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/owners/all" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <OwnersList />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/owner/details/:ownerId" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <OwnerDetails />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/trainer/account" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <TrainerAccount />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/trainer/working-hours" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <TrainerWorkingHoursContent />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/exercises" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <Exercises />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/trainings/confirmed" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <TrainerTrainings />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />
                                    {/*TODO: naprawić grupy*/}
                                    {/*<Route path="/trainer/groups" element={*/}
                                    {/*    <PrivateRoute>*/}
                                    {/*        <TrainerProvider>*/}
                                    {/*            <ErrorBoundary>*/}
                                    {/*                <TrainerGroups />*/}
                                    {/*            </ErrorBoundary>*/}
                                    {/*        </TrainerProvider>*/}
                                    {/*    </PrivateRoute>*/}
                                    {/*} />*/}
                                    {/*<Route path="/trainer/group/:groupId" element={*/}
                                    {/*    <PrivateRoute>*/}
                                    {/*        <TrainerProvider>*/}
                                    {/*            <ErrorBoundary>*/}
                                    {/*                <TrainerGroupDetails />*/}
                                    {/*            </ErrorBoundary>*/}
                                    {/*        </TrainerProvider>*/}
                                    {/*    </PrivateRoute>*/}
                                    {/*} />*/}
                                    <Route path="/reports" element={
                                        <PrivateRoute>
                                            <TrainerProvider>
                                                <ErrorBoundary>
                                                    <TrainerReportsManagement />
                                                </ErrorBoundary>
                                            </TrainerProvider>
                                        </PrivateRoute>
                                    } />

                                    <Route path="/owner/dashboard" element={
                                        <PrivateRoute>
                                            <OwnerProvider>
                                                <ErrorBoundary>
                                                    <OwnerDashboard />
                                                </ErrorBoundary>
                                            </OwnerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/owner/my-dog" element={
                                        <PrivateRoute>
                                            <OwnerProvider>
                                                <ErrorBoundary>
                                                    <OwnerMyDog />
                                                </ErrorBoundary>
                                            </OwnerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/owner/trainings" element={
                                        <PrivateRoute>
                                            <OwnerProvider>
                                                <ErrorBoundary>
                                                    <OwnerTrainings />
                                                </ErrorBoundary>
                                            </OwnerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/owner/calendar" element={
                                        <PrivateRoute>
                                            <OwnerProvider>
                                                <ErrorBoundary>
                                                    <OwnerCalendar />
                                                </ErrorBoundary>
                                            </OwnerProvider>
                                        </PrivateRoute>
                                    } />
                                    <Route path="/owner/account" element={
                                        <PrivateRoute>
                                            <OwnerProvider>
                                                <ErrorBoundary>
                                                    <OwnerAccount />
                                                </ErrorBoundary>
                                            </OwnerProvider>
                                        </PrivateRoute>
                                    } />
                                </Routes>

                                {/* Blocking modal - shows when subscription is locked */}
                                <SubscriptionModal />
                            </div>
                        </ErrorBoundary>
                    </SubscriptionProvider>
                </Router>
                <ToastContainer />
            </ToastProvider>
        </ErrorBoundary>
    );
};

export default App;